import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalPenuh extends React.Component {
    render() {
        const { showModalPenuh, CancelHandler, DeleteHandler2, Model, List, editHandler, createHandler } = this.props

        return (
            <div>
                
                <Modal show={showModalPenuh} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>CEK KETERSEDIAAN JADWAL</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Mohon maaf, waktu kedatangan yang anda pilih sudah terisi penuh.
                            Silahkan pilih waktu kedatangan yang lain <br /> <br />
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={CancelHandler}>Batal</button>
                        <button class="btn btn-danger" onClick={()=>{editHandler(Model._id)}}>Pilih Jadwal Lain </button>
                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}